import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import Progress from '../components/progress/progress.jsx';
import {closeHomeworkUploadProgress} from '../reducers/modals';

const HomeworkUploadProgress = ({
    num,
    onRequestClose,
    text,
    title
}) => (<Progress
    num={num}
    text={text}
    title={title}
    onRequestClose={onRequestClose}
/>);
HomeworkUploadProgress.propTypes = {
    num: PropTypes.number,
    onRequestClose: PropTypes.func.isRequired,
    text: PropTypes.string,
    title: PropTypes.string
};

const mapStateToProps = state => ({
    num: state.scratchGui.modals.uploadHomeworkProgressNum,
    text: '正在上传您的作品，请稍等几分钟...',
    title: '提示'
});

const mapDispatchToProps = dispatch => ({
    onRequestClose: () => dispatch(closeHomeworkUploadProgress())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HomeworkUploadProgress);
